import { register, getPrefix, isTouchDevice } from '../../../Utils'

const Tooltip = el => {
  const prefix = getPrefix(el)
  const container = el.querySelector(`.${prefix}content`)
  const containerPosition = container.getBoundingClientRect()
  const offset = document.body.clientWidth > 700 ? 20 : 0

  // Funktioniert nicht richtig + translate nimmt den content nicht wirklich von der Seite.
  // Fehler kam durch mobiles update?
  if (containerPosition.left < 0) {
    container.style.transform = `translateX(${containerPosition.left * (-1) + offset}px)`
  } else if (containerPosition.right > document.body.clientWidth) {
    container.style.transform = `translateX(-${containerPosition.right - document.body.clientWidth + offset}px)`
  }

  if (isTouchDevice()) {
    el.addEventListener('click', () => el.classList.toggle(`${prefix}is--visible`))
  }
}

register('Tooltip', Tooltip)
